<template>
<div class="card">
    <div class="card-body">
        <div class="d-flex justify-content-between">
            <div class="d-flex">
                <span class="me-3">
                    <img :src="absoluteUrl(item.user.image)" alt="user-image" class="rounded avatar-md" />
                </span>
                <span class="">
                    <h6 class="mb-1 mt-0">
                        {{item.user.name}}
                    </h6>
                    <div class="text-muted small mb-1">
                        <i class="bx bxs-flag-alt me-1"></i>
                        <span v-if="item.country">{{item.country.name}} </span>
                    </div>
                    <div class="text-muted">
                        <i class="bx bxs-star text-warning" v-for="rate in item.rating" :key="rate"></i>
                    </div>
                </span>
            </div>
            <slot name="actions"></slot>
        </div>
        <div class="pt-3">
            {{item.content}} 
        </div>
        <hr class="my-2"/>
        <div class="text-muted">
            <div class="row">
                <div class="col-6">
                    <div>
                        <p class="text-truncate mb-1">Product</p>
                        <div class="my-0" v-if="item.product">
                            <router-link :to="'/products/'+item.product.id">{{ item.product.name }}</router-link>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="text-end">
                        <p class="text-truncate mb-1">Reviewed Date</p>
                        <div class=""><span class="badge bg-success"> {{ $filters.date(item.reviewed_at)}}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props:{
        item:{
            type: Object,
            required: true
        }
    }
}
</script>

<style>

</style>